export default __webpack_public_path__ + "static/media/ticket.cd9c675a.svg";